module.exports = __webpack_public_path__ + "img/anonymous-profile.fb1e55cf.svg";